import { GenericButtonProps, Generic } from './GenericButton';

export function PrimaryButton(props: GenericButtonProps) {
    const bgClass = props.disabled
        ? 'border-theme-outline bg-theme-950/40 text-theme-text/30'
        : 'border-button-primary-border bg-button-primary/80 text-white hover:border-blue-300 hover:bg-button-primary focus-visible:ring-blue-400/25';

    return <Generic {...props} className={bgClass + (props.className ? ' ' + props.className : '')} />;
}
